import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <div className="header">
      <h1>Dashboard</h1>
      <div className="header-right">
        <span className="welcome-text">Welcome, Admin</span>
        <span className="user-avatar">👤</span>
      </div>
    </div>
  );
};

export default Header;

